const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ROLE_META = {
  staff:      { label: 'Staff',       hex: '#94A3B8' },
  manager:    { label: 'Manager',     hex: '#10B981' },
  executive:  { label: 'Executive',   hex: '#8A2BE2' },
  admin:      { label: 'Admin',       hex: '#00E5FF' },
  superadmin: { label: 'Super Admin', hex: '#F59E0B' },
};

export const roleMeta = (role) => ROLE_META[role] || ROLE_META.staff;

const GRADIENTS = ['from-cyan-500 to-blue-600', 'from-violet-500 to-purple-600', 'from-emerald-500 to-teal-600', 'from-rose-500 to-pink-600', 'from-amber-500 to-orange-600', 'from-indigo-500 to-blue-600'];

export const gradientFor = (seed) => GRADIENTS[(seed || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0) % GRADIENTS.length];

export const initialsOf = (name) => (name || '?').split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);

export const avatarUrlOf = (avatar) => {
  if (!avatar) return null;
  if (avatar.startsWith('http')) return avatar;
  return `${BACKEND_URL}${avatar.startsWith('/api') ? avatar : '/api' + avatar}`;
};

export const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const relativeTime = (d) => {
  if (!d) return 'Never';
  const mins = Math.floor((Date.now() - new Date(d).getTime()) / 60000);
  if (mins < 60) return `${Math.max(mins, 0)}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return formatDate(d);
};

export const daysSince = (d) => d ? (Date.now() - new Date(d).getTime()) / 86400000 : Infinity;

export const startDateOf = (s) => s.hire_date || s.created_at;

export const isProbation = (s) => daysSince(startDateOf(s)) <= 90;

export const isNewThisMonth = (s) => {
  const d = startDateOf(s);
  if (!d) return false;
  const dt = new Date(d); const now = new Date();
  return dt.getMonth() === now.getMonth() && dt.getFullYear() === now.getFullYear();
};

export const downloadCsv = (rows, cols, filename) => {
  const csv = [cols.join(',')].concat(rows.map(r => cols.map(c => JSON.stringify(r[c] ?? '')).join(','))).join('\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};
